import { produce } from 'immer';

export const ImmerFuncs = {
  produce,
};
